// extracted by mini-css-extract-plugin
export default {"dogContainer":"z8eVNp","menu":"AyEM_1"};